import {
  alphabeticalSorter,
  alphabeticalSorterFor,
  getRenderLink,
} from '../shared/TableLayout';
import isDesktop from '../../utils/sizeHelpers';
import React from 'react';
import { IntlShape } from 'react-intl';
import { VehicleProfileInfoData, BrandData } from '../../@types';

export const getBrandNameById = (
  brands: any,
  brandId: string
): string | null => {
  if (brands == null) {
    return null;
  }

  return (
    brands?.find((brand: { id: string }) => brand.id === brandId)?.name || null
  );
};

const getColumns = (brands: BrandData[], intl: IntlShape) => {
  const renderBrand = (brandId: string) => (
    <span>{getBrandNameById(brands, brandId)}</span>
  );

  return [
    {
      title: intl.formatMessage({
        id: 'fleetadmin.profile.table.name',
        defaultMessage: 'Name',
      }),
      dataIndex: 'name',
      ellipsis: true,
      width: isDesktop() ? 200 : 150,
      fixed: 'left' as 'left',
      render: getRenderLink(),
      sorter: alphabeticalSorterFor('name'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.profile.table.brand',
        defaultMessage: 'Brand',
      }),
      dataIndex: 'brandId',
      ellipsis: true,
      width: 200,
      render: renderBrand,
      sorter: (
        profileA: VehicleProfileInfoData,
        profileB: VehicleProfileInfoData
      ) => {
        const brandNameA = getBrandNameById(brands, profileA?.brandId!);
        const brandNameB = getBrandNameById(brands, profileB?.brandId!);
        return alphabeticalSorter(brandNameA, brandNameB);
      },
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.profile.table.vehiclebrand',
        defaultMessage: 'Vehicle Brand',
      }),
      dataIndex: 'brandName',
      ellipsis: true,
      width: 150,
      sorter: alphabeticalSorterFor('brandName'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.profile.table.vehiclemodel',
        defaultMessage: 'Vehicle Model',
      }),
      dataIndex: 'model',
      ellipsis: true,
      width: 200,
      sorter: alphabeticalSorterFor('model'),
    },
  ];
};

export default getColumns;
